define('controller/sub/ClientSubController',['require','lib/controller/BaseController','lib/terms/ClientTermsController','view/controller/sub/ClientInfoLayout','lib/WindowMessageListener'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var ClientTermsController = require('lib/terms/ClientTermsController');
    var ClientInfoLayout = require('view/controller/sub/ClientInfoLayout');
    var WindowMessageListener = require('lib/WindowMessageListener');

    /**
     * Client info sub controller
     *
     * @class ClientSubController
     */
    return BaseController.extend({

        _view: null,
        _model: null,
        _termsController: null,

        /**
         * Initialize client sub controller
         */
        initialize: function () {
            this._model = this.getOption('clientModel');

            this._termsController = ClientTermsController.getInstance({
                'client': this._model
            });

            var listener = new WindowMessageListener();
            this.listenTo(listener, 'message', _.bind(this._handleWindowMessage, this));
        },

        /**
         * Handle open id login message
         *
         * @private
         */
        _handleWindowMessage: function (data) {
            if (data.open_id_message) {
                if (data.user_data) {
                    this._model.set({
                        'name': data.user_data.user_name,
                        'email': data.user_data.user_email
                    });
                    if (this._view && !this._view.isDestroyed) {
                        this._view.render();
                    }
                }
            }
        },

        /**
         * Creates and returns client info view
         */
        createView: function () {
            this._termsController.getModel().fetch();

            this._view = new ClientInfoLayout({
                model: this._model,
                termsModel: this._termsController.getModel(),
                formTitle: this.getOption('formTitle'),
                formSubTitle: this.getOption('formSubTitle'),
                backButtonLabel: this.getOption('backButtonLabel'),
                backButtonLink: this.getOption('backButtonLink'),
                submitButtonLabel: this.getOption('submitButtonLabel')
            });

            this.listenTo(this._view, 'render', function () {
                this._view.showTermsAndConditions(this._termsController.getView());
            });
            this.listenTo(this._view, 'save:client', this.performSave);

            return this._view;
        },

        performSave: function () {
            var clientIsValid = this._model.isValid();
            var termsAreValid = this._termsController.validate();

            this._model.set('terms', this._termsController.getModel().getAcceptedTerms(), {
                silent: true
            });

            if (clientIsValid && termsAreValid) {
                this._model.save(null, {
                    success: _.bind(function () {
                        this.triggerMethod('client:saved', this._model);
                    }, this)
                });
            }
        }

    });

});
